class Speech {
  constructor(line, emotion = null, shouldTalk = true) {
    this.line = line;
    this.emotion = emotion;
    this.shouldTalk = shouldTalk;
  }
}

export default Speech;
